$(function() {
	// content hacks
	let s = $('.m-section-overlap');
	s.prev().addClass('m-section-overlap-prev');
	s.next().addClass('m-section-overlap-next');

	// media&reviews show more
	const $articlesWrapper = $('.content-review-articles');
	const $more = $('.content-review-articles-more');
	$more.on('click', function() {
		$articlesWrapper.children().slideDown(200);
		$more.hide();
	})


});
